import { OauthServiceType } from '@websky/graphql';
import { getLocale } from '@websky/core/src/utils';
const currentLocale = getLocale();
export const companyInfo = {
    facebook: '',
    instagram: '',
    vk: 'https://vk.com/azurair',
    baggage: 'https://www.azurair.ru/ru/flights/baggage',
    meal: 'https://www.azurair.ru/ru/services/azur-meal',
    seat: 'https://www.azurair.ru/ru/services/azur-space',
    legal: `https://www.azurair.ru/${currentLocale}/for-passengers/fly-rules`,
    privacyPolicy: 'https://www.azurair.ru/ru/azurair/privacy-policy',
    exarePrivacyPolicyURL: 'https://www.azurair.ru/ru/flights/fly-rules',
    exareRulesURL: 'https://www.azurair.ru/ru/flights/fly-tariffs',
    insurance: ``,
    subsidyRulesUrl: ``,
    loyaltyProgramRegistrationUrl: ``,
    loyaltyProgramName: '',
    iataCode: 'ZF',
    loyalty: {
        links: [
            {
                title: 'Status',
                url: ``
            },
            {
                title: 'Earn miles',
                url: ``
            },
            {
                title: 'Use miles',
                url: ``
            },
            {
                title: 'FAQ',
                url: ``
            }
        ]
    },
    multiInsurance: true,
    specialDocumentForInsurance: false,
    subsidyFaresConditionURL: ''
};
export const i18n = {
    ru: {
        Title: {
            companyName: 'Azur Air'
        },
        AddPassenger: {
            Find: 'Добавить'
        },
        SeatMap: {
            SeatMap_Preferred: 'AZUR Space',
            '- Joint seating, if one was originally selected;': '— Совместная рассадка, если она была выбрана изначально;',
            '- Placement in the front row of the cabin, if one was originally selected.': '— Размещение в первом ряду салона, если оно было выбрано изначально.',
            'In the event of an aircraft replacement, passengers who have paid for the “seat selection” service will be provided with seats on the plane that are similar in price and comfort, while maintaining the following parameters': 'В случае замены воздушного судна, пассажирам, оплатившим услугу «Выбор места», будут предоставлены места в самолете, аналогичные по цене и комфортности с сохранением следующих параметров'
        },
        Checkin: {
            'Online check-in will close at': 'Онлайн-регистрация завершится в',
            'airport local time': 'по местному времени аэропорта вылета',
            'Check-in Successful': 'Регистрация пройдена. До встречи на борту!',
            'Ticket number or booking reference': 'Номер билета',
            'Enter the passenger last name (in latin characters) and the booking code. \nYou can find it in the itinerary receipt sent to your email after booking.': 'В форме укажите номер билета и фамилию пассажира. \nПосле этого нажмите на кнопку «Поиск».',
            'Online check-in': 'Онлайн-регистрация'
        },
        BaggageService: {
            'Your can bring your ski, snowboard, surf equipment, bicycle, etc. packed in a pouch': 'Вы сможете взять с собой в чехле лыжи, сноуборд или велосипед'
        },
        LoginPage: {
            'Email / Phone / Card number': 'Эл. почта'
        },
        SearchFormDatepicker: {
            'Without back date': 'Обратный билет не нужен'
        },
        Forms: {
            'Order number': 'Номер заказа или код бронирования',
            'Ticket number': 'Номер билета',
            'My booking': 'Управление заказом'
        },
        RetrieveBooking: {
            'Enter your book code or order number': 'Введите номер заказа или код бронирования',
            'Enter your book code or ticket number': 'Введите номер билета'
        },
        IncludedBaggage: {
            Equipment: 'Дополнительные услуги',
            'Need to bring sports, music or baby equipments?': 'Вам нужно перевезти спортивное или музыкальное оборудование, детскую коляску или взять в путешествие питомца?'
        },
        Consents: {
            agreement_rules: 'Я ознакомился(-лась) с {{links}}, оплатой данных доп. услуг, принимаю их и согласен с ними.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">правилами страхования</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'условиями публичной оферты «{{name}}»'
        },
        OrderCard: {
            'Online check-in started': 'Онлайн-регистрация открыта',
            'Check-in': 'Онлайн-регистрация'
        },
        BaggagePage: {
            'Transportation of impressions no limitations': 'Дополнительное багажное место для всего самого необходимого'
        },
        MealPage: {
            'Feel the taste in flight': 'Предварительный заказ любимых блюд'
        },
        Checkout: {
            'Feel the taste in flight!': 'Предварительный заказ любимых блюд',
            'Transportation of impressions no limitations': 'Дополнительное багажное место для всего самого необходимого',
            'Go to online check-in': 'Онлайн-регистрация'
        },
        Account: {
            'Online check-in': 'Онлайн-регистрация'
        },
        OrderSummary: {
            'Check-in': 'Онлайн-регистрация'
        }
    },
    en: {
        Title: {
            companyName: 'Azur Air'
        },
        AddPassenger: {
            Find: 'Add'
        },
        SeatMap: {
            SeatMap_Preferred: 'AZUR Space'
        },
        SearchFormDatepicker: {
            'Without back date': 'No return ticket needed'
        },
        Checkin: {
            'Enter the passenger last name (in latin characters) and the booking code. \nYou can find it in the itinerary receipt sent to your email after booking.': 'Enter the passenger last name (in latin characters) and the ticket number. \nYou can find it in the itinerary receipt sent to your email after booking.',
            'Ticket number or booking reference': 'Ticket number'
        },
        LoginPage: {
            'Email / Phone / Card number': 'Email'
        },
        Forms: {
            Checkin: 'Online Check-in'
        },
        RetrieveBooking: {
            'Enter your book code or order number': 'Enter your book code or order number',
            'Enter your book code or ticket number': 'Enter your ticket number',
            'Incorrect value': 'Incorrect last name'
        },
        IncludedBaggage: {
            Equipment: 'Additional services',
            'Need to bring sports, music or baby equipments?': 'Need to bring sports, music or baby equipments or take a pet on a trip?'
        },
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        BaggagePage: {
            'Transportation of impressions no limitations': 'Extra luggage space for everything you need'
        },
        MealPage: {
            'Feel the taste in flight': 'Pre-order your favorite dishes'
        },
        Checkout: {
            'Feel the taste in flight!': 'Pre-order your favorite dishes',
            'Transportation of impressions no limitations': 'Extra luggage space for everything you need'
        }
    },
    kk: {
        Title: {
            companyName: 'Azur Air'
        },
        SeatMap: {
            SeatMap_Preferred: 'AZUR Space'
        },
        LoginPage: {
            'Email / Phone / Card number': 'Email'
        },
        SearchFormDatepicker: {
            'Without back date': 'Қайту билеті қажет емес'
        },
        RetrieveBooking: {
            'Enter your book code or order number': 'Тапсырыс нөмірін немесе брондау кодын енгізіңіз',
            'Enter your book code or ticket number': 'Билет нөмірін немесе брондау кодын енгізіңіз'
        },
        IncludedBaggage: {
            Equipment: 'Жабдық',
            'Need to bring sports, music or baby equipments?': 'Саяхатқа спорттық немесе музыкалық жабдықтарды, арбаны немесе үй жануарларын тасымалдау керек пе?'
        },
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        OrderCard: {
            'Online check-in started': 'Онлайн-тіркеу ашық',
            'Check-in': 'Онлайн-тіркеу'
        },
        BaggagePage: {
            'Transportation of impressions no limitations': 'Барлық қажетті заттар үшін қосымша жүк орны'
        },
        MealPage: {
            'Feel the taste in flight': 'Сүйікті тағамдарыңызға алдын ала тапсырыс беріңіз'
        },
        Checkout: {
            'Feel the taste in flight!': 'Сүйікті тағамдарыңызға алдын ала тапсырыс беріңіз',
            'Transportation of impressions no limitations': 'Барлық қажетті заттар үшін қосымша жүк орны',
            'Go to online check-in': 'Онлайн-тіркеу'
        },
        Account: {
            'Online check-in': 'Онлайн-тіркеу'
        },
        OrderSummary: {
            'Check-in': 'Онлайн-тіркеу'
        },
        Checkin: {
            'Online check-in': 'Онлайн-тіркеу'
        }
    },
    fr: {
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        BaggagePage: {
            'Transportation of impressions no limitations': 'Espace de bagages supplémentaire pour tout ce dont vous avez besoin'
        },
        MealPage: {
            'Feel the taste in flight': 'Précommandez vos plats préférés'
        },
        Checkout: {
            'Feel the taste in flight!': 'Précommandez vos plats préférés',
            'Transportation of impressions no limitations': 'Espace de bagages supplémentaire pour tout ce dont vous avez besoin'
        }
    },
    de: {
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        BaggagePage: {
            'Transportation of impressions no limitations': 'Zusätzlicher Gepäckraum für alles, was Sie brauchen'
        },
        MealPage: {
            'Feel the taste in flight': 'Bestellen Sie Ihre Lieblingsgerichte vor'
        },
        Checkout: {
            'Feel the taste in flight!': 'Bestellen Sie Ihre Lieblingsgerichte vor',
            'Transportation of impressions no limitations': 'Zusätzlicher Gepäckraum für alles, was Sie brauchen'
        }
    },
    zh: {
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        },
        BaggagePage: {
            'Transportation of impressions no limitations': '额外的行李空间，满足您的一切需求'
        },
        MealPage: {
            'Feel the taste in flight': '预先订购你最喜欢的菜肴'
        },
        Checkout: {
            'Feel the taste in flight!': '预先订购你最喜欢的菜肴',
            'Transportation of impressions no limitations': '额外的行李空间，满足您的一切需求'
        }
    }
};
export const config = {
    global: {
        findOrderURL: 'https://www.azurair.ru/booking/#/find/',
        showIsActualizationResultOk: false,
        allowPromoCodes: false,
        showZeroCharges: true,
        maxBaggage: 3,
        maxBaggagePerPassenger: 3,
        companyInfo,
        dynamicBaggagePricing: false,
        i18n,
        reserveEngines: {
            checkin: 'https://booking.azurair.ru/web-checkin/',
            redirectToWebsky1: true,
            siteUrl: 'https://www.azurair.ru/'
        },
        socialAuthMethods: [
            {
                service: OauthServiceType.Vkontakte,
                isAvailable: true
            }
        ],
        authMethods: {
            phone: false,
            ffp: false
        }
    },
    Engine: {
        calendarDaysCount: 5,
        checkInURL: './online-check-in',
        checkInEnabled: true,
        showAvailableFaresOnly: true
    },
    SearchForm: {
        showPricesInDatepicker: true,
        engineURL: 'https://azurair.ru/booking',
        payByMiles: false
    },
    FlightStatus: {
        playMarketURL: '',
        appStoreURL: ''
    }
};
